import { render, staticRenderFns } from "./KuecheEG.vue?vue&type=template&id=2b7e116a"
import script from "./KuecheEG.vue?vue&type=script&lang=js"
export * from "./KuecheEG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports